<template>
  <focus-trap :escapeDeactivates="false" :clickDeactivates="false">
    <div
      class="print-options-popup-for-medical-payments"
      tabindex="-1"
      @keyup.esc.stop="close"
    >
      <popup
        :contentStyle="{}"
        :buttons="['閉じる', '印刷']"
        @cancel="close"
        @click-close-mark="close"
        @decision="openPdf"
      >
        <template v-slot:content>
          <div class="content">
            <div class="title">診療明細書一括印刷</div>
            <div class="form">
              <div class="form-item" data-test="paper-size">
                <div class="label">用紙サイズ</div>
                <div class="input-field">
                  <div class="radio-buttons size">
                    <base-radio-button
                      v-for="option in radios.paperSize"
                      :input-styles="radioButtonStyle"
                      :key="'paper-size' + option.id"
                      :option="option"
                      v-model="printOptions.paperSize"
                    />
                  </div>
                </div>
              </div>
              <div class="form-item" data-test="clinic-name">
                <div class="label">医院名</div>
                <div class="input-field">
                  <div class="radio-buttons">
                    <base-radio-button
                      v-for="option in radios.clinicName"
                      :input-styles="radioButtonStyle"
                      :key="'clinic-' + option.id"
                      :option="option"
                      v-model="printOptions.showClinicName"
                    />
                  </div>
                </div>
              </div>
              <div class="form-item" data-test="clinic-tel">
                <div class="label">医院電話番号</div>
                <div class="input-field">
                  <div class="radio-buttons">
                    <base-radio-button
                      v-for="option in radios.clinicTel"
                      :input-styles="radioButtonStyle"
                      :key="'clinic-' + option.id"
                      :option="option"
                      v-model="printOptions.showClinicTel"
                    />
                  </div>
                </div>
              </div>
              <div class="form-item" data-test="clinic-email">
                <div class="label">医院メールアドレス</div>
                <div class="input-field">
                  <div class="radio-buttons">
                    <base-radio-button
                      v-for="option in radios.clinicEmail"
                      :input-styles="radioButtonStyle"
                      :key="'clinic-' + option.id"
                      :option="option"
                      v-model="printOptions.showClinicEmail"
                    />
                  </div>
                </div>
              </div>
              <div class="form-item" data-test="clinic-address">
                <div class="label">医院住所</div>
                <div class="input-field">
                  <div class="radio-buttons">
                    <base-radio-button
                      v-for="option in radios.clinicAddress"
                      :input-styles="radioButtonStyle"
                      :key="'clinic-' + option.id"
                      :option="option"
                      v-model="printOptions.showClinicAddress"
                    />
                  </div>
                </div>
              </div>
              <div
                v-if="showFormItemInvoiceNumber"
                class="form-item"
                data-test="invoice-number"
              >
                <div class="label">登録番号</div>
                <div class="input-field">
                  <div class="radio-buttons">
                    <base-radio-button
                      v-for="option in radios.invoiceNumber"
                      :input-styles="radioButtonStyle"
                      :key="option.id"
                      :option="option"
                      v-model="printOptions.showInvoiceNumber"
                    />
                  </div>
                </div>
              </div>
              <div class="form-item" data-test="barcode">
                <div class="label">
                  <span>自己負担額バーコード</span>
                  <div class="footnote-mark">※1</div>
                </div>
                <div class="input-field">
                  <div class="radio-buttons">
                    <base-radio-button
                      v-for="option in radios.barcode"
                      :input-styles="radioButtonStyle"
                      :key="option.id"
                      :option="option"
                      v-model="printOptions.showBarcode"
                    />
                  </div>
                </div>
              </div>
              <div class="footnote">
                <span
                  >※1）自己負担額が7桁以上の場合バーコードは表示できません。</span
                >
              </div>
            </div>
          </div>
        </template>
      </popup>
    </div>
  </focus-trap>
</template>

<script>
import BaseRadioButton from '@/components/parts/atoms/BaseRadioButton'
import Popup from '@/components/popups/Popup'
import moment from 'moment'
import { FocusTrap } from 'focus-trap-vue'
import { mapGetters } from 'vuex'
import { printMedicalPayment } from '@/utils/print_medical_payment'

export default {
  name: 'PrintOptionsPopupForMedicalPayments',

  components: {
    BaseRadioButton,
    FocusTrap,
    Popup
  },

  props: {
    checkedMedicalPayments: { type: Array, required: true },
    hospitalizations: { type: Array, required: true },
    medicalRecords: { type: Array, required: true },
    medicalTreatmentItems: { type: Array, required: true },
    medicalPayments: { type: Array, required: true }
  },

  data() {
    return {
      printOptions: {},
      radioButtonStyle: { paddingLeft: '20px' },
      radios: {
        barcode: [
          { id: 'barcode-true', eachValue: true, labelName: '表示する' },
          { id: 'barcode-false', eachValue: false, labelName: '表示しない' }
        ],
        clinicAddress: [
          { id: 'address-true', eachValue: true, labelName: '表示する' },
          { id: 'address-false', eachValue: false, labelName: '表示しない' }
        ],
        clinicEmail: [
          { id: 'email-true', eachValue: true, labelName: '表示する' },
          { id: 'email-false', eachValue: false, labelName: '表示しない' }
        ],
        clinicName: [
          { id: 'name-true', eachValue: true, labelName: '表示する' },
          { id: 'name-false', eachValue: false, labelName: '表示しない' }
        ],
        clinicTel: [
          { id: 'tel-true', eachValue: true, labelName: '表示する' },
          { id: 'tel-false', eachValue: false, labelName: '表示しない' }
        ],
        invoiceNumber: [
          { id: 'invoice-true', eachValue: true, labelName: '表示する' },
          { id: 'invoice-false', eachValue: false, labelName: '表示しない' }
        ],
        paperSize: [
          { id: 'A4', eachValue: 'A4', labelName: 'A4' },
          { id: 'B5', eachValue: 'B5', labelName: 'B5' },
          { id: 'A5', eachValue: 'A5', labelName: 'A5' }
        ]
      },
      showFormItemInvoiceNumber: false
    }
  },

  computed: {
    ...mapGetters({
      clinic: 'clinic/getData',
      getDisease: 'diseases/getDataById',
      getMasterDatum: 'master/getDataById',
      getMedicine: 'medicines/getDataById',
      getOwner: 'owners/getDataById',
      getPatient: 'patients/getDataById',
      getStaff: 'staffs/getDataById',
      getTreatment: 'treatments/getDataById',
      printSetting: 'printSetting/getData'
    })
  },

  created() {
    const showInvoiceNumber = !!this.clinic.invoiceNumber
    if (showInvoiceNumber) this.showFormItemInvoiceNumber = true
    this.printOptions = {
      paperSize: this.printSetting.defaultPaperSize,
      showBarcode: !!this.printSetting.barcodeFlg,
      showClinicAddress: !!this.printSetting.printClinicAddressFlg,
      showClinicEmail: !!this.printSetting.printClinicEmailFlg,
      showClinicName: !!this.printSetting.printClinicNameFlg,
      showClinicTel: !!this.printSetting.printClinicTelFlg,
      showInvoiceNumber
    }
  },

  methods: {
    close() {
      this.$emit('close')
    },
    formatDate(YYYYMMDD, showWeekday = false) {
      const weekday = showWeekday ? '（dd）' : ''
      const output = `Y年M月D日${weekday}`
      return moment(YYYYMMDD, 'YYYYMMDD').format(output)
    },
    formatTime(HHmm) {
      return moment(HHmm, 'HHmm').format('H:mm')
    },
    makeItemName(item) {
      const name = item.treatmentId
        ? this.getTreatment(item.treatmentId).name
        : item.medicineId
        ? this.getMedicine(item.medicineId).name
        : ''
      return name
    },
    makeTreatmentDate(medicalRecord) {
      const date = this.formatDate(medicalRecord.date, true)
      const start = this.formatTime(medicalRecord.startTime)
      const end = this.formatTime(medicalRecord.endTime)
      return `${date}${start}~${end}`
    },
    makeTreatmentItemData(medicalPayment, medicalTreatmentItems) {
      return medicalTreatmentItems
        .filter(v => v.medicalPaymentId === medicalPayment.id)
        .map(v => {
          const name = this.makeItemName(v)
          return { ...v, name }
        })
        .sort((a, b) => a.order - b.order)
    },
    openPdf() {
      const checkedMedicalPayments = this.checkedMedicalPayments
      const hospitalizations = this.hospitalizations
      const medicalTreatmentItems = this.medicalTreatmentItems
      const hospitalizationMedicalPayments = this.medicalPayments
      const medicalRecords = this.medicalRecords
      const prefecture = this.getMasterDatum(
        'prefectures',
        this.clinic.prefectureId
      )
      const prefectureName = prefecture?.name ?? ''
      const clinic = { ...this.clinic, prefectureName }
      const clinicImage = this.printSetting.image
      // PDF処理に必要な印刷内容一覧の作成
      const printData = checkedMedicalPayments.map(medicalPayment => {
        const medicalRecord = medicalRecords.find(
          r => r.originalId === medicalPayment.medicalRecordOriginalId
        )
        const hospitalization = hospitalizations.find(
          h => h.endMedicalPaymentOriginalId === medicalPayment.originalId
        )
        medicalPayment.date = this.formatDate(medicalRecord.date)
        if (hospitalization) {
          medicalPayment.hospitalization = hospitalization
          medicalPayment.hospitalizationMedicalPayments = hospitalization.medicalPaymentOriginalIds
            .map(originalId => {
              const hospitalizationMedicalPayment = hospitalizationMedicalPayments.find(
                h => h.originalId === originalId
              )
              const medicalRecord = medicalRecords.find(
                r =>
                  r.originalId ===
                  hospitalizationMedicalPayment.medicalRecordOriginalId
              )
              const dateTime = medicalRecord.date + medicalRecord.startTime
              return { ...hospitalizationMedicalPayment, dateTime }
            })
            .sort((a, b) => a.dateTime - b.dateTime)
          medicalPayment.treatmentItemsAndTreatmentDates = medicalPayment.hospitalizationMedicalPayments.flatMap(
            medicalPayment => {
              const treatmentItems = this.makeTreatmentItemData(
                medicalPayment,
                medicalTreatmentItems
              )
              if (!(treatmentItems.length > 0)) return []
              const medicalRecord = medicalRecords.find(
                r => r.originalId === medicalPayment.medicalRecordOriginalId
              )
              const treatmentDate = this.makeTreatmentDate(medicalRecord)
              return [{ treatmentDate }, ...treatmentItems]
            }
          )
          medicalPayment.treatmentItems = medicalPayment.hospitalizationMedicalPayments.flatMap(
            medicalPayment =>
              this.makeTreatmentItemData(medicalPayment, medicalTreatmentItems)
          )
        } else {
          medicalPayment.treatmentItems = this.makeTreatmentItemData(
            medicalPayment,
            medicalTreatmentItems
          )
        }
        medicalPayment.onsetDate = medicalPayment.uncertainOnsetFlg
          ? '不明'
          : this.formatDate(medicalPayment.onsetDate)
        const { disease1Id, disease2Id } = medicalPayment
        medicalPayment.diseaseName = [disease1Id, disease2Id]
          .flatMap(v => this.getDisease(v)?.name ?? [])
          .join(', ')
        const staff = this.getStaff(medicalPayment.staffId)
        medicalPayment.staffName = staff
          ? staff.lastName + ' ' + staff.firstName
          : ''
        const patient = this.getPatient(medicalPayment.patientId)
        const owner = this.getOwner(patient.ownerId)
        return { owner, patient, medicalPayment }
      })
      // 一括印刷では バーコード と 次回予約 は非表示
      printMedicalPayment({
        printOptions: this.printOptions,
        barcodePrefix: this.printSetting.barcodePrefix,
        clinic,
        clinicImage,
        printData
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.print-options-popup-for-medical-payments {
  position: absolute;
  top: 0;
  left: 0;
  .content {
    min-width: 460px;
    font-size: 15px;
    text-align: left;
    > .title {
      font-size: 16px;
      font-weight: bold;
    }
    > .form {
      margin-top: 25px;
      display: flex;
      flex-direction: column;
      row-gap: 10px;
      > .form-item {
        display: flex;
        align-items: center;
        height: 33px;
        > .label {
          width: 200px;
          display: flex;
          align-items: center;
          > .footnote-mark {
            margin-left: 6px;
            font-size: 12px;
          }
        }
        > .input-field {
          flex: 1;
          display: flex;
          align-items: center;
          > .radio-buttons {
            display: flex;
            column-gap: 20px;
            &.size {
              column-gap: 10px;
            }
          }
        }
      }
      > .footnote {
        font-size: 12px;
      }
    }
  }
}
</style>
